// Auditoria geral da programação Havan: rótulos legíveis, valores e período no formato da API.

export const TIPOS_ACAO_AUDITORIA = {
  importacao: 'Importação',
  inclusao: 'Inclusão manual',
  alteracao: 'Alteração',
  exclusao: 'Exclusão',
  envio_tms: 'Envio ao TMS'
};

// Campos gravados na auditoria (nome da coluna no banco) com o nome que a tela mostra.
export const CAMPOS_AUDITORIA = {
  codigo_motorista_tms: 'Código do motorista no TMS',
  cpf_motorista: 'CPF do motorista',
  nome_motorista: 'Motorista',
  telefone_motorista: 'Telefone do motorista',
  numero_frota: 'Frota',
  codigo_veiculo_tms: 'Código do veículo no TMS',
  placa_cavalo: 'Placa cavalo',
  placa_carreta_1: 'Carreta 1',
  placa_carreta_2: 'Carreta 2',
  placa_carreta_3: 'Carreta 3',
  terceiro: 'Terceiro',
  protocolo: 'Protocolo',
  gestor_avisado: 'Gestor avisado',
  observacao_operador: 'Observação',
  vx: 'VX',
  tms: 'TMS',
  frota: 'Frota própria',
  cancelado: 'Cancelada',
  motorista_manual: 'Motorista informado pelo operador',
  conjunto_manual: 'Conjunto informado pelo operador'
};

export const rotuloTipoAcao = tipo => TIPOS_ACAO_AUDITORIA[tipo] || tipo || '-';
export const rotuloCampo = campo => (campo ? CAMPOS_AUDITORIA[campo] || campo : '-');

// Booleanos como Sim/Não; vazio (nulo) aparece como "vazio" para deixar claro que o campo foi limpo ou preenchido.
export const formatarValorAuditoria = valor => {
  if (valor === null || valor === undefined || valor === '') return 'vazio';
  if (valor === 'true' || valor === true) return 'Sim';
  if (valor === 'false' || valor === false) return 'Não';
  return String(valor);
};

// Ações que não são alteração de campo: resume o JSON gravado (importação: quantas cargas; TMS: o retorno).
export const resumirDetalhe = (tipo, detalhe) => {
  if (!detalhe) return '';
  let dados;
  try {
    dados = JSON.parse(detalhe);
  } catch {
    return detalhe;
  }
  if (!dados || typeof dados !== 'object') return detalhe;
  if (tipo === 'importacao') {
    const partes = Object.entries(dados)
      .filter(([, valor]) => Array.isArray(valor) || typeof valor === 'number')
      .map(([chave, valor]) => `${chave.replace(/_/g, ' ')}: ${Array.isArray(valor) ? valor.length : valor}`);
    return partes.length ? partes.join(' · ') : detalhe;
  }
  if (tipo === 'inclusao') {
    const filial = [dados.filial_codigo, dados.filial_nome].filter(Boolean).join(' - ');
    return [filial ? `Filial ${filial}` : null, dados.turno ? `${dados.turno}º turno` : null, dados.box ? `Box ${dados.box}` : null]
      .filter(Boolean).join(' · ') || detalhe;
  }
  if (tipo === 'envio_tms') {
    const ambiente = dados.ambiente ? `TMS ${dados.ambiente}` : 'TMS';
    return dados.mensagem ? `${ambiente}: ${dados.mensagem}` : `${ambiente}: aceito`;
  }
  return detalhe;
};

// O filtro de data devolve o horário local "AAAA-MM-DD HH:mm"; a API recebe em UTC.
// O fim inclui o minuto inteiro (até hh:mm:59.999).
export const periodoParaApi = (valor, fim = false) => {
  const partes = /^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2}))?$/.exec(String(valor || '').trim());
  if (!partes) return undefined;
  const [, ano, mes, dia, hora, minuto] = partes;
  const temHora = hora !== undefined;
  const data = new Date(
    Number(ano), Number(mes) - 1, Number(dia),
    temHora ? Number(hora) : fim ? 23 : 0,
    temHora ? Number(minuto) : fim ? 59 : 0,
    fim ? 59 : 0,
    fim ? 999 : 0
  );
  return Number.isNaN(data.getTime()) ? undefined : data.toISOString();
};
